import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { inr } from "../../lib/format";
import { panel, inputCls, btnPrimary, PageHead } from "../ui";
import { Copy, Trash2, Plus, Pencil } from "lucide-react";

export default function Products() {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const load = () => admin.get(`/admin/products${q ? `?q=${q}` : ""}`).then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  const savePrice = async (p, price) => {
    await admin.put(`/admin/products/${p.id}`, { price: Number(price) });
    toast.success("Price updated");
  };
  const toggleStatus = async (p) => {
    const status = p.status === "active" ? "draft" : "active";
    await admin.put(`/admin/products/${p.id}`, { status });
    load();
  };
  const duplicate = async (p) => { await admin.post(`/admin/products/${p.id}/duplicate`); toast.success("Duplicated"); load(); };
  const del = async (p) => { if (!window.confirm(`Delete ${p.name}?`)) return; await admin.delete(`/admin/products/${p.id}`); toast.success("Deleted"); load(); };

  return (
    <div>
      <PageHead title="Products">
        <input placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} className={`${inputCls} w-40 sm:w-56`} data-testid="product-search" />
        <Link to="/admin/products/new" className={btnPrimary + " flex items-center gap-1.5"} data-testid="admin-product-add-btn"><Plus size={14} /> Add</Link>
      </PageHead>

      {!list ? <p className="text-zinc-500">Loading…</p> : (
        <div className={`${panel} overflow-x-auto`}>
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-widest text-zinc-500 border-b border-zinc-800">
              <th className="p-3">Product</th><th className="p-3">Price</th><th className="p-3">Stock</th><th className="p-3">Status</th><th className="p-3"></th>
            </tr></thead>
            <tbody>
              {list.map((p) => (
                <tr key={p.id} className="border-b border-zinc-900 hover:bg-zinc-900/30" data-testid={`product-row-${p.slug}`}>
                  <td className="p-3">
                    <div className="flex items-center gap-3">
                      <img src={p.images?.[0]?.url} alt="" className="w-10 h-12 object-cover bg-zinc-900" />
                      <div><p className="text-zinc-100 line-clamp-1">{p.name}</p><p className="text-[11px] text-zinc-600">{p.sku}</p></div>
                    </div>
                  </td>
                  <td className="p-3">
                    <input defaultValue={p.price} onBlur={(e) => savePrice(p, e.target.value)}
                      className="w-24 bg-zinc-950 border border-zinc-800 px-2 py-1 text-sm" data-testid={`price-input-${p.slug}`} />
                  </td>
                  <td className="p-3"><span className={p.total_stock === 0 ? "text-red-400" : p.total_stock <= 5 ? "text-amber-400" : "text-zinc-300"}>{p.total_stock}</span></td>
                  <td className="p-3">
                    <button onClick={() => toggleStatus(p)} className={`text-[11px] uppercase tracking-wider px-2 py-1 ${p.status === "active" ? "text-accent border border-accent-ss" : "text-zinc-400 border border-zinc-700"}`} style={p.status === "active" ? { borderColor: "var(--ss-accent)" } : {}} data-testid={`status-toggle-${p.slug}`}>{p.status}</button>
                  </td>
                  <td className="p-3">
                    <div className="flex items-center gap-2 justify-end">
                      <button onClick={() => navigate(`/admin/products/${p.id}`)} className="text-zinc-400 hover:text-white" title="Edit" data-testid={`edit-${p.slug}`}><Pencil size={15} /></button>
                      <button onClick={() => duplicate(p)} className="text-zinc-400 hover:text-white" title="Duplicate"><Copy size={15} /></button>
                      <button onClick={() => del(p)} className="text-zinc-400 hover:text-red-400" title="Delete" data-testid={`delete-${p.slug}`}><Trash2 size={15} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
